import { useState } from 'react';
import { auth } from '../firebase/firebase';
import { sendPasswordResetEmail } from 'firebase/auth';
import { Link } from 'react-router-dom';
import { ReactComponent as Logo } from '../censuszen-logo.svg';
import '../styles/Auth.css';

export const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        try {
            await sendPasswordResetEmail(auth, email);
        } catch (err) {
            // Don't reveal whether the email exists (prevents enumeration)
            if (err.code !== 'auth/user-not-found') {
                setError('Failed to send reset email. Please try again.');
                return;
            }
        }
        // Always show success to prevent email enumeration
        setSubmitted(true);
    };

    return (
        <div className="auth-page">
            <div className="auth-container">
                <Link to="/" className="auth-logo-link">
                    <Logo className="auth-logo" aria-label="CensusZen" />
                </Link>
                {submitted ? (
                    <div className="auth-form">
                        <h2 className="auth-title">Check your email</h2>
                        <p className="auth-success">
                            If an account exists for that email, a password reset link has been sent.
                            Please check your inbox.
                        </p>
                        <div className="auth-links">
                            <Link to="/login">Back to sign in</Link>
                        </div>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit} className="auth-form">
                        <h2 className="auth-title">Reset your password</h2>
                        <p className="auth-subtitle">Enter your email and we'll send a reset link</p>
                        {error && <div className="auth-error">{error}</div>}
                        <div className="auth-field">
                            <label htmlFor="resetEmail">Email</label>
                            <input
                                id="resetEmail"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                autoComplete="username"
                                placeholder="you@example.com"
                            />
                        </div>
                        <button type="submit" className="auth-submit">Send Reset Link</button>
                        <div className="auth-links">
                            <Link to="/login">Back to sign in</Link>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
};
